/*
 Flagship Standard Config (i.e. Hubbard Radio markets)
 */

const markets = [
  "Cincinnati",
  "Chicago",
  "Phoenix",
  "Seattle",
  "St. Louis",
  "Twin Cities",
  "Washington",
  "West Palm Beach",
  "Northern MN",
  "NMN Alexandria",
  "NMN Bemidji",
  "NMN Brainerd",
  "NMN Wadena",  
  "Hub",
];

const services = [
  {
    value: "analytics",
    text: "Analytics",
    flighted: false,
  },
  {
    value: "auditing-consulting",
    text: "Auditing/Consulting",
    subOptions: [
      {
        value: "ppc-audit",
        text: "PPC Audit",
        flighted: false,
      },
      {
        value: "social-audit",
        text: "Social Audit",
        flighted: false,
      },
      {
        value: "web-audit",
        text: "Website Audit",
        flighted: false,
      },
      {
        value: "consulting",
        text: "Consulting",
        flighted: false,
      },
    ],
  },
  {
    value: "content",
    text: "Content",
    subOptions: [
      {
        value: "blog",
        text: "Blog",
        flighted: false,
      },
      {
        value: "graphics",
        text: "Graphics",
        flighted: false,
      },
      {
        value: "video",
        text: "Video Production",
        flighted: false,
      },
    ],
  },
  {
    value: "display",
    text: "Display",
    subOptions: [
      { value: "location", text: "Location", flighted: true },
      { value: "ip-targeting", text: "Addressable", flighted: true },
      { value: "mobile-expandable", text: "Mobile Expandable", flighted: true },
      { value: "native", text: "Native", flighted: true },
      {
        value: "outreach-retargeting",
        text: "Behavioral",
        flighted: true,
      },
      {
        value: "foot-traffic-attribution",
        text: "Outreach w/ Foot Traffic",
        flighted: true,
      },
      {
        value: "display-programmatic-beta",
        text: "Programmatic (BETA)",
        flighted: true,
      },
      {
        value: "display-digital-ooh-beta",
        text: "Digital OOH (BETA)",
        flighted: true,
      },
    ],
  },
  {
    value: "email-marketing-parent",
    text: "Email Marketing",
    subOptions: [
      {
        value: "email-marketing",
        text: "Email Marketing",
        flighted: true,
      },
      {
        value: "email-management",
        text: "Email Management",
        flighted: false,
      },
    ],
  },
  {
    value: "ppc",
    text: "Pay-Per-Click",
    flighted: true,
  },
  {
    value: "reputation-management",
    text: "Reputation Management (Legacy)",
    flighted: false,
    deactivated: true,
  },
  {
    value: "search-engine-optimization",
    text: "Search Engine Optimization",
    subOptions: [
      {
        value: "seo",
        text: "Search Engine Optimization (Legacy)",
        flighted: false,
        deactivated: true,
      },
      {
        value: "seo-local",
        text: "MapConnect (Local)",
        flighted: false,
      },
      {
        value: "seo-organic",
        text: "Organic SEO",
        flighted: false,
      },
    ],
  },
  {
    value: "social-media",
    text: "Social Media",
    subOptions: [
      {
        value: "social-media-management",
        text: "Renewal - Full Social Media Management",
        flighted: false,
      },
      {
        value: "social-media-ads",
        text: "Social Media Ads Only",
        flighted: true,
      },
      {
        value: "social-media-refresh",
        text: "Social Media Refresh",
        flighted: false,
      },
      {
        value: "social-media-sweepstakes",
        text: "Social Media Sweepstakes",
        flighted: false,
      },
      {
        value: "social-media-influencers",
        text: "Social Media Influencers",
        flighted: false,
      },
    ],
  },
  {
    value: "streaming-audio",
    text: "Streaming Audio",
    subOptions: [
      {
        value: "prog-audio",
        text: "Programmatic Audio",
        flighted: true,
      },
      {
        value: "prog-podcast",
        text: "Programmatic Podcast",
        flighted: true,
      },
      {
        value: "audio-programmatic-beta",
        text: "Programmatic (BETA)",
        flighted: true,
      },
    ],
  },
  {
    value: "website",
    text: "Website",
    subOptions: [
      {
        value: "website-redesign",
        text: "Full Web Design & Development (Legacy)",
        flighted: false,
        deactivated: true,
      },
      {
        value: "website-update",
        text: "Existing Website Update",
        flighted: false,
      },
      {
        value: "website-campaign-landing-page",
        text: "Campaign Landing Page",
        flighted: false,
      },
      {
        value: "website-landing-page",
        text: "WordPress Landing Page (Legacy)",
        flighted: false,
        deactivated: true,
      },
      {
        value: "website-hosting",
        text: "Web Hosting Renewal",
        flighted: false,
      },
    ],
  },
  {
    value: "video-parent",
    text: "Video",
    subOptions: [
      {
        value: "addressable-ott",
        text: "Addressable OTT",
        flighted: true,
      },
      {
        value: "addressable-video",
        text: "Addressable Video",
        flighted: true,
      },
      {
        value: "ott-ctv",
        text: "OTT/CTV",
        flighted: true,
      },
      {
        value: "prog-video",
        text: "Programmatic Video",
        flighted: true,
      },
      {
        value: "youtube",
        text: "YouTube",
        flighted: true,
      },
      {
        value: "video-programmatic-beta",
        text: "Programmatic (BETA)",
        flighted: true,
      },
    ],
  },
  {
    value: "add-ons",
    text: "Add-Ons",
    subOptions: [
       {
        text: "CallRail",
        value: "callrail",
        flighted: true,
      },
      {
        text: "Creative Add-On: Display & Social (Animated) - $1,400",
        value: "creative-add-on-display-social-animated-design-copy-1400",
        flighted: false,
      },
      {
        text: "Creative Add-On: Display & Social (Static) - $975",
        value: "creative-add-on-display-social-static-design-copy-963",
        flighted: false,
      },
      {
        text: "Creative Add-On: Display (Animated) - $1,225",
        value: "creative-add-on-display-animated-design-copy-1225",
        flighted: false,
      },
      {
        text: "Creative Add-On: Display (Static) - $875",
        value: "creative-add-on-display-static-design-copy-875",
        flighted: false,
      },
      {
        text: "Creative Add-On: Email - $1,325",
        value: "creative-add-on-email-design-copy-1313",
        flighted: false,
      },
      {
        text: "Creative Add-On: Print (One-Page Flyer) - $1,225",
        value: "creative-add-on-print-one-page-flyer-design-copy-1225",
        flighted: false,
      },
      {
        text: "Creative Add-On: Print (Tri-Fold) - $1,575",
        value: "creative-add-on-print-tri-fold-design-copy-1575",
        flighted: false,
      },
      {
        text: "Creative Add-On: Social (Animated) - $1,050",
        value: "creative-add-on-social-animated-design-copy-1050",
        flighted: false,
      },
      {
        text: "Creative Add-On: Social (Static) - $700",
        value: "creative-add-on-social-static-design-copy-700",
        flighted: false,
      },
      {
        text: "Creative Add-On: Website Graphic - $700",
        value: "creative-add-on-website-graphic-design-copy-700",
        flighted: false,
      },
      {
        text: "Creative Add-On: Brand Audit: - $2,500",
        value: "creative-add-on-brand-audit-2500",
        flighted: false,
      },
      {
        text: "Creative Add-On: User Personas: - $1,575",
        value: "creative-add-on-user-personas-1575",
        flighted: false,
      },
      {
        text: "Creative Add-On: Logo Development: - $5,000",
        value: "creative-add-on-logo-development-5000",
        flighted: false,
      },
      {
        text: "Creative Add-On: Brand Identity: - $1,750",
        value: "creative-add-on-brand-identity-1750",
        flighted: false,
      },
      {
        text: "Creative Add-On: Brand Guidelines: - $2,500",
        value: "creative-add-on-brand-guidelines-2500",
        flighted: false,
      },
      {
        text: "Creative Add-On: Naming Services: - $1,750",
        value: "creative-add-on-naming-services-1750",
        flighted: false,
      },
      {
        text: "Campaign Add-On: Conversion Tracking (up to 2 events) - $500",
        value: "campaign-add-on-conversion-tracking-up-to-2-events-500",
        flighted: false,
      },
    ],
  },
];

export default {
  markets: markets,
  lineItemServices: services,
  logo: "/assets/logo@2x.png",
  userGroups: [
    "Content & Influencers",
    "Creative",
    "Data & Analytics",
    "Paid Media",
    "Proposal Strategy",
    "QA & Support",
    "Web & SEO",
    "Other",
  ],
};



// WEBPACK FOOTER //
// ./src/config/instances/standard.js